module.exports = __webpack_public_path__ + "img/k4.860ed627.png";